module.exports = __webpack_public_path__ + "img/zm.a008ab8a.png";